<div class="response-drawer">
  <div class="response-drawer-header">
    <div class="response-drawer-title-wrap">
      <h2 class="response-drawer-title">{{ tradeBy || 'Response' }}<span *ngIf="rowStatus" class="response-drawer-title-status"> | {{ rowStatus | titlecase }}<span *ngIf="deferredExpirationDate && (rowStatus | uppercase) === 'DEFERRED'"> ({{ deferredExpirationDate }})</span></span></h2>
    </div>
    <img
      src="assets/img/account-activity-icn-window.png"
      class="response-drawer-close"
      alt="Close"
      (click)="close()"
    />
  </div>

  <div class="response-drawer-frames">
    <section class="response-frame">
      <header class="response-frame-header">Response Log</header>
      <div class="response-frame-body" #responseLogScroll>
        <div class="response-log-list">
          <ng-container *ngFor="let log of groupedResponseLogs; let idx = index">
            <div *ngIf="idx > 0" class="response-log-separator">
              <span class="response-log-separator-date">{{ getCreatedDateEst(log.createdDate) }}</span>
            </div>
            <article class="response-log-card" [class.response-log-card-secondary]="idx > 0">
              <div class="response-log-top">
                <div class="response-log-user-wrap">
                  <div class="response-log-avatar">{{ getInitials(log.createdBy) }}</div>
                  <div class="response-log-user">
                    <div class="response-log-email">{{ log.createdBy }}</div>
                  </div>
                </div>
                <div class="response-log-date-wrap">
                  <div class="response-log-date">{{ getCreatedDateEstPart(log.createdDate, 'date') }}</div>
                  <div class="response-log-time">{{ getCreatedDateEstPart(log.createdDate, 'time') }}</div>
                </div>
              </div>

              <div class="response-log-section">
                <div class="response-log-label">Report Type | Month | Year</div>
                <div class="response-log-value">{{ reportType || 'N/A' }} | {{ getMonthNameFromDate(log.createdDate) }} | {{ getYearFromDate(log.createdDate) }}</div>
              </div>

              <div class="response-log-section" *ngIf="log.responses && log.responses.length">
                <div class="response-log-label">Response:</div>
                <ul class="response-log-value response-log-bullets">
                  <li *ngFor="let resp of log.responses" class="response-log-bullet-item" [class.response-log-other-item]="isOtherResponseText(resp)">
                    <span *ngIf="!isRichText(resp)">{{ resp }}</span>
                    <div *ngIf="isRichText(resp)" class="response-rich-text" [innerHTML]="sanitizeHtml(resp)"></div>
                  </li>
                </ul>
              </div>

              <div class="response-log-section" *ngIf="log.documents && log.documents.length">
                <div class="response-log-label">Uploaded Files:</div>
                <div class="response-log-value">
                  <div *ngFor="let doc of log.documents" class="uploaded-file-item">
                    <a class="uploaded-file-name" title="Download - {{ doc.documentName }}" (click)="downloadDoc(doc)">{{ doc.documentName }}</a>
                    <div class="uploaded-file-desc" *ngIf="doc.documentDesc">{{ doc.documentDesc }}</div>
                  </div>
                </div>
              </div>
            </article>
          </ng-container>
          <div *ngIf="!groupedResponseLogs || groupedResponseLogs.length === 0" class="response-log-empty">No response logs available.</div>

          <div *ngIf="otherResponseLogs.length" class="show-more-wrap">
            <button type="button" class="show-more-btn" (click)="toggleShowMore()">{{ showAllLogs ? 'Show less' : 'Show more...' }}</button>
          </div>

          <ng-container *ngIf="showAllLogs">
            <ng-container *ngFor="let log of otherResponseLogs; let idx = index">
              <div class="response-log-separator">
                <span class="response-log-separator-date">{{ getCreatedDateEst(log.createdDate) }}</span>
              </div>
              <article class="response-log-card response-log-card-secondary">
                <div class="response-log-top">
                  <div class="response-log-user-wrap">
                    <div class="response-log-avatar">{{ getInitials(log.createdBy) }}</div>
                    <div class="response-log-user">
                      <div class="response-log-email">{{ log.createdBy }}</div>
                    </div>
                  </div>
                  <div class="response-log-date-wrap">
                    <div class="response-log-date">{{ getCreatedDateEstPart(log.createdDate, 'date') }}</div>
                    <div class="response-log-time">{{ getCreatedDateEstPart(log.createdDate, 'time') }}</div>
                  </div>
                </div>
                <div class="response-log-section">
                  <div class="response-log-label">Report Type | Month | Year</div>
                  <div class="response-log-value">{{ reportType || 'N/A' }} | {{ getMonthNameFromDate(log.createdDate) }} | {{ getYearFromDate(log.createdDate) }}</div>
                </div>
                <div class="response-log-section" *ngIf="log.responses && log.responses.length">
                  <div class="response-log-label">Response:</div>
                  <ul class="response-log-value response-log-bullets">
                    <li *ngFor="let resp of log.responses" class="response-log-bullet-item" [class.response-log-other-item]="isOtherResponseText(resp)">
                      <span *ngIf="!isRichText(resp)">{{ resp }}</span>
                      <div *ngIf="isRichText(resp)" class="response-rich-text" [innerHTML]="sanitizeHtml(resp)"></div>
                    </li>
                  </ul>
                </div>
                <div class="response-log-section" *ngIf="log.documents && log.documents.length">
                  <div class="response-log-label">Uploaded Files:</div>
                  <div class="response-log-value">
                    <div *ngFor="let doc of log.documents" class="uploaded-file-item">
                      <a class="uploaded-file-name" title="Download - {{ doc.documentName }}" (click)="downloadDoc(doc)">{{ doc.documentName }}</a>
                      <div class="uploaded-file-desc" *ngIf="doc.documentDesc">{{ doc.documentDesc }}</div>
                    </div>
                  </div>
                </div>
              </article>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </section>

    <section class="response-frame">
      <header class="response-frame-header">Record Response</header>
      <div class="response-frame-body">
        <div class="record-response-form">
          <!-- Response options (dynamic) -->
          <ng-container *ngIf="responseOptionsReady">
            <ng-container *ngFor="let opt of responseOptions; let i = index">
              <div class="response-option-row" *ngIf="!opt.isOther">
                <input [id]="'rec-option-' + i" type="checkbox" class="response-option-checkbox" [(ngModel)]="opt.checked" />
                <label [for]="'rec-option-' + i" class="response-option-label">{{ opt.description }}</label>
              </div>
              <div *ngIf="opt.isOther" class="response-option-row other-response-row">
                <div class="other-response-editor-wrap">
                  <div class="other-textarea-wrap">
                    <textarea
                      #otherTextarea
                      class="other-textarea"
                      [placeholder]="opt.description"
                      maxlength="2000"
                      [(ngModel)]="opt.otherText"
                      (ngModelChange)="onOtherTextChanged($event, opt)"
                      (input)="autoResize(otherTextarea)">
                    </textarea>
                    <span class="other-textarea-hint">{{ (opt.otherText || '').length }}/2000</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Divider always visible between options and documents/deferred -->
          <hr class="section-divider" />

          <!-- Deferred Until -->
          <ng-container *ngIf="showDeferredOption">
          <div class="response-option-row deferred-row">
            <input id="rec-deferred" type="checkbox" class="response-option-checkbox" [(ngModel)]="recordResponse.deferredChecked" [disabled]="!isCONReportType && (isDeferredStatus || isClosedStatus)" />
            <label for="rec-deferred" class="response-option-label">Deferred Until</label>
            <mat-form-field class="record-field record-field-small datepicker-field" appearance="outline">
              <input matInput [matDatepicker]="deferredPicker" [(ngModel)]="recordResponse.deferredDate" [disabled]="!recordResponse.deferredChecked" readonly [min]="today" [max]="maxDate" placeholder="Select Date" />
              <mat-datepicker-toggle matSuffix [for]="deferredPicker"></mat-datepicker-toggle>
              <mat-datepicker #deferredPicker [disabled]="!recordResponse.deferredChecked"></mat-datepicker>
            </mat-form-field>
          </div>
          <div *ngIf="deferredDateError" class="deferred-date-error">* Cannot Save without selecting Deferred Date</div>
          <hr class="section-divider" />
          </ng-container>

          <!-- Supporting document -->
          <div class="record-section-label">Upload Supporting Documents</div>
          <div *ngIf="zeroFileSizeError" class="file-size-error">* File size is 0 KB. Please upload a valid file.</div>
          <div *ngIf="fileSizeError" class="file-size-error">* Total file size exceeds 20 MB. Please remove some files.</div>
          <div class="upload-zone" (click)="fileInput.click()" (dragover)="$event.preventDefault()" (drop)="onFileDrop($event)">
            <input #fileInput type="file" multiple (change)="onFileSelected($event)" hidden />
            <mat-icon class="upload-icon">upload_file</mat-icon>
            <p class="upload-text"><span class="upload-browse">Browse</span> to select file</p>
            <p class="upload-hint">Please upload Documents up to size of 20 MB.</p>
          </div>
          <div *ngIf="selectedFiles.length" class="selected-files-list">
            <div *ngFor="let file of selectedFiles; let i = index" class="selected-file-item">
              <span class="selected-file-name">{{ file.name }}</span>
              <mat-form-field class="selected-file-desc" appearance="fill">
                <input matInput placeholder="Document Description" [(ngModel)]="fileDescriptions[i]" />
              </mat-form-field>
              <button type="button" class="remove-file-btn" (click)="removeFile(i)">&times;</button>
            </div>
          </div>
        </div>

        <div class="response-actions">
          <button type="button" class="response-btn response-btn-cancel" (click)="close()">Cancel</button>
          <button type="button" class="response-btn response-btn-submit" [disabled]="!canSubmit || showProgress" (click)="submitResponse()">Submit response</button>
        </div>
      </div>
    </section>
  </div>
</div>
